"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
require("./dialogHeader.less");
var Props = /** @class */ (function () {
    function Props() {
    }
    return Props;
}());
exports.Props = Props;
var DialogBlueHeader = /** @class */ (function (_super) {
    __extends(DialogBlueHeader, _super);
    function DialogBlueHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogBlueHeader.prototype.render = function () {
        return React.createElement("div", { className: this.classNames },
            React.createElement("h2", { className: 'text-ellipsis' }, this.props.line1),
            React.createElement("h4", { className: 'text-ellipsis' }, this.props.line2));
    };
    Object.defineProperty(DialogBlueHeader.prototype, "classNames", {
        get: function () {
            var linesClass = this.hasTwoLines ? "dialog-header-blue-two-lines" : "dialog-header-blue-one-line";
            return classnames("dialog-header", "dialog-header-blue", "l-box-h-2x", "l-box-v-1-2x", linesClass);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DialogBlueHeader.prototype, "hasTwoLines", {
        get: function () {
            return !!this.props.line2;
        },
        enumerable: true,
        configurable: true
    });
    return DialogBlueHeader;
}(React.Component));
exports.DialogBlueHeader = DialogBlueHeader;
